import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	authContainer: {
		height: "100%"
	},
	authContent: {
		height: "100%"
	},
	authWrapper: {
		margin: "auto 0"
	},
	portlet: {
		padding: `${theme.spacing(5)}px 10%`
	},
	logo: {
		display: "block",
		margin: "0 auto",
		maxWidth: "150px",
		height: "auto"
	},
	tabs: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderRadius: "6px 6px 0px 0px"
	},
	tab: {
		fontSize: "14px",
		fontWeight: "normal"
	},
	signInFormHelperText: {
		marginTop: theme.spacing(1),
		textAlign: "center"
	},
	whiteText: {
		color: colors.gray[0]
	},
	whiteInput: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderWidth: 0
	},
	whiteLabelInput: {
		background: colors.gray[0],
		padding: "0 6px",
		borderRadius: "9px"
	},
	whiteBackground: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		color: colors.getPrimaryColor()
	},
	whiteButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		color: colors.getPrimaryColor(),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
			opacity: 0.9
		}
	}
}))

export default useStyles
